// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

import { PlacementFrontend } from '@post-office/browser--jira-werewolves/admin-agent-recommendation';

import { MessageFrontend as createMessageFrontendJiraTriageAgentRecommendation } from '@post-office/browser--jira-werewolves/jira-triage-agent-recommendation/placements/in-app-v2/admin-agent-recommendation';
import { MessageFrontend as createMessageFrontendJiraCodingAgentRecommendation } from '@post-office/browser--jira-werewolves/jira-coding-agent-recommendation/placements/in-app-v2/admin-agent-recommendation';

import { withI18n } from './i18n';

import { type PlacementRendererStage } from '@post-office/message-maker-browser/types';
import { type ComponentType, type ComponentProps } from 'react';

const messageFrontends = [
	createMessageFrontendJiraTriageAgentRecommendation({
		messageTemplateId: 'jira-triage-agent-recommendation',
	}),
	createMessageFrontendJiraCodingAgentRecommendation({
		messageTemplateId: 'jira-coding-agent-recommendation',
	}),
];

export const RawPlacement: ReturnType<typeof PlacementFrontend.createPlacementFrontendComponent> =
	PlacementFrontend.createPlacementFrontendComponent({
		messageTemplates: messageFrontends,
	});

type GeneratedPlacementProps = ComponentProps<typeof RawPlacement>;

export const Placement: ComponentType<
	Omit<GeneratedPlacementProps, 'ref'> & {
		ref?: unknown;
	}
> = withI18n(RawPlacement);

export const SSRPlacement: PlacementRendererStage<GeneratedPlacementProps> = RawPlacement;
